import {Item} from '../../../models/Item';
import {AbstractMainPlugin} from '../../AbstractMainPlugin';



export class VertexPlugin extends AbstractMainPlugin {

  constructor(item: Item) {
    super(item);
    this.initListeners();
  }
  static getBeforeItemComponents() {
    return [];
  }
  private initListeners() {
    this.item.getObservable('pointAdded').subscribe((index)=>{
      this.updateInputsByIndex(index);
    })
  }


  private updateInputsByIndex(index){
    let inputs = this.item.config.getInputs();
    for (let i in inputs){
      let input = inputs[i];
      if (input.hasOwnProperty('per_vertex')){
        let value = input.value;
        if (Array.isArray(value)){
          value.splice(index, 0, input.default_prop_value || 0);
        }
        this.item.config.setInputValue(i, 'value', value);
      }
    }
  }
}
